import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../core/config/config.service';

export interface ServerStatus {
  status: 'UP' | 'DOWN';
  bancoDados: 'UP' | 'DOWN';
  versao: string;
  perfil: string;
}

@Injectable({ providedIn: 'root' })
export class SistemaService {
  private readonly configService = inject(ConfigService);

  constructor(private http: HttpClient) {}

  private get statusUrl(): string {
    return `${this.configService.settings()?.apiUrl}/sistema/status`;
  }

  getStatus(): Observable<ServerStatus> {
    return this.http.get<ServerStatus>(this.statusUrl);
  }
}
